  (function() {
    let cartSwiperInstance = null;
    let observer = null;
    function debounce(func, delay) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), delay);
      };
    }

    function initCartSwiper() {
      if (observer) {
        observer.disconnect();
      }

      if (cartSwiperInstance && typeof cartSwiperInstance.destroy === 'function') {
        cartSwiperInstance.destroy(true, true);
        cartSwiperInstance = null;
      }

      const swiperEl = document.querySelector('.cartswiper');
      if (!swiperEl) {
        console.warn('[CartSwiper] no .cartswiper element found');
        if (observer && document.querySelector('.cart-drawer')) {
          observer.observe(document.querySelector('.cart-drawer'), {
            childList: true,
            subtree: true
          });
        }
        return;
      }

      const slides = swiperEl.querySelectorAll('.swiper-slide');
      if (slides.length === 0) {
        console.warn('[CartSwiper] no slides found in .cartswiper');
        if (observer && document.querySelector('.cart-drawer')) {
          observer.observe(document.querySelector('.cart-drawer'), {
            childList: true,
            subtree: true
          });
        }
        return;
      }

      try {
        cartSwiperInstance = new Swiper(swiperEl, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      } catch (err) {
        console.error('[CartSwiper] initialization error:', err);
      }

      if (observer && document.querySelector('.cart-drawer')) {
        observer.observe(document.querySelector('.cart-drawer'), {
          childList: true,
          subtree: true
        });
      }
    }

    function setupObserver() {
      const drawerEl = document.querySelector('.cart-drawer');
      if (!drawerEl) {
        console.warn('[CartSwiper] no .cart-drawer element found for observer');
        return;
      }

      if (observer) {
        observer.disconnect();
      }

      const debouncedInit = debounce(() => {
        initCartSwiper();
      }, 300);

      observer = new MutationObserver(debouncedInit);
      observer.observe(drawerEl, {
        childList: true,
        subtree: true
      });
    }

    function refreshCart() {
      fetch('/cart.js', { credentials: "same-origin" })
        .then(r => r.json())
        .then(cart => {
          setTimeout(() => {
            initCartSwiper();
          }, 300);
        })
        .catch(err => {
          console.warn('[CartSwiper] Unable to fetch /cart.js:', err);
          setTimeout(() => {
            initCartSwiper();
          }, 300);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initCartSwiper();
        setupObserver();
      });
    } else {
      initCartSwiper();
      setupObserver();
    }

    document.addEventListener('cart:update', (e) => {
      const cart = e?.detail?.cart || e?.detail?.resource || null;
      if (cart && typeof cart.items !== "undefined") {
        setTimeout(() => {
          initCartSwiper();
        }, 300);
      } else {
        refreshCart();
      }
    });

    document.addEventListener('cart:change', (e) => {
      const cart = e?.detail?.cart || e?.detail?.resource || null;
      if (cart && typeof cart.items !== "undefined") {
        setTimeout(() => {
          initCartSwiper();
        }, 300);
      } else {
        refreshCart();
      }
    });

    document.addEventListener('cart:open', () => {
      refreshCart();
    });
  })();


// features collection swiper starts here

const swiper = new Swiper('.feature-swiper', {
  slidesPerView: 4.6,
  spaceBetween: 16,
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  loop: false,
  watchOverflow: true,

  breakpoints: {
    0: {       
      slidesPerView: 1.4,
      spaceBetween: 12,
    },
    640: {        
      slidesPerView: 2.2,
      spaceBetween: 14,
    },
    1024: {       
      slidesPerView: 3.2,
      spaceBetween: 16,
    },
    1280: {      
      slidesPerView: 4.6,
      spaceBetween: 16,
    }
  }
});

// features collection swiper ends here


// Quntity bundler starts here

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector('.template-product-subscription')) {
    return;
  }

  function initializeBundleQuantity() {
    const oneTimeBundle = document.querySelector('.bundle-quantity.one-time');
    const subscriptionBundle = document.querySelector('.bundle-quantity.subscription');
    const addToCartBtn = document.querySelector('[name="add"]');
    const priceDisplay = document.querySelector('.add-to-cart-text__content');
    let selectedQuantity = 1;

    // base price
    let basePrice = 0;
    if (addToCartBtn && addToCartBtn.dataset.price) {
      basePrice = parseFloat(addToCartBtn.dataset.price);
      if (isNaN(basePrice)) {
        return;
      }
    } else {
      return;
    }

    function formatPrice(price) {
      return `€${price.toFixed(2).replace('.', ',')}`;
    }

    function getBundleDiscountPercentage(card) {
      if (!card) return 0;
      const discountElement = card.querySelector('.quantity-cart-discount');
      if (discountElement) {
        const discountText = discountElement.textContent.trim();
        const match = discountText.match(/\+(\d+)%\s*Off/i);
        if (match) return parseInt(match[1], 10) / 100;
      }
      return 0;
    }

    // update displayed prices (add-to-cart and both Appstle wrappers)
    // NOTE: updateCartButton controls whether the Add-to-Cart area is updated.
    function updatePrice(quantity, bundleDiscount, updateCartButton = true) {
      if (!priceDisplay || isNaN(basePrice) || basePrice <= 0 || isNaN(quantity)) {
        return;
      }

      const originalPrice = basePrice * quantity;
      const discountedPrice = originalPrice * (1 - bundleDiscount);

      // add-to-cart area — update only if allowed
      if (updateCartButton) {
        priceDisplay.innerHTML = `Add to cart | <span class="discounted-price">${formatPrice(discountedPrice)}</span> <span class="original-price" style="display: ${discountedPrice === originalPrice ? 'none' : 'inline'}">${formatPrice(originalPrice)}</span>`;
      } else {
      }

      // Appstle: One Time wrapper (value update)
      const oneTimeOption = document.querySelector('input[name="selling_plan"][value=""]');
      if (oneTimeOption) {
        const oneTimeWrapper = oneTimeOption.closest('.appstle_subscription_wrapper_option');
        if (oneTimeWrapper && oneTimeBundle) {
          const oneTimeCards = oneTimeBundle.querySelectorAll('.quantity-card-item');
          const oneTimeSelectedCard = oneTimeBundle.querySelector('.quantity-card-item.active') || oneTimeCards[0];
          const oneTimeDiscount = getBundleDiscountPercentage(oneTimeSelectedCard);
          const oneTimeQty = parseInt(oneTimeSelectedCard.querySelector('.quantity-cart-number').dataset.qunatity, 10) || 1;
          const oneTimeOriginal = basePrice * oneTimeQty;
          const oneTimeDiscounted = oneTimeOriginal * (1 - oneTimeDiscount);

          const amount = oneTimeWrapper.querySelector('.appstle_subscription_amount');
          const amountSr = oneTimeWrapper.querySelector('.appstle_subscription_amount-appstle-sr-only');
          const compareAmount = oneTimeWrapper.querySelector('.appstle_subscription_amount_compare_at_price');
          const compareAmountSr = oneTimeWrapper.querySelector('.appstle_subscription_amount_compare_at_price-appstle-sr-only');

          if (amount) amount.textContent = formatPrice(oneTimeDiscounted);
          if (amountSr) amountSr.textContent = `Sale price ${formatPrice(oneTimeDiscounted)}`;
          if (compareAmount) {
            compareAmount.textContent = formatPrice(oneTimeOriginal);
            compareAmount.style.display = oneTimeDiscounted === oneTimeOriginal ? 'none' : 'inline';
          }
          if (compareAmountSr) {
            compareAmountSr.textContent = `Original price ${formatPrice(oneTimeOriginal)}`;
            compareAmountSr.style.display = oneTimeDiscounted === oneTimeOriginal ? 'none' : 'inline';
          }
        }
      }

      // Appstle: Subscription wrapper (value update)
      const subscriptionOption = document.querySelector('input[name="selling_plan"][value="691497795927"]');
      if (subscriptionOption) {
        const subscriptionWrapper = subscriptionOption.closest('.appstle_subscription_wrapper_option');
        if (subscriptionWrapper && subscriptionBundle) {
          const subscriptionCards = subscriptionBundle.querySelectorAll('.quantity-card-item');
          const subscriptionSelectedCard = subscriptionBundle.querySelector('.quantity-card-item.active') || subscriptionCards[0];
          const subscriptionDiscount = getBundleDiscountPercentage(subscriptionSelectedCard);
          const subscriptionQty = parseInt(subscriptionSelectedCard.querySelector('.quantity-cart-number').dataset.qunatity, 10) || 1;
          const subscriptionOriginal = basePrice * subscriptionQty;
          const subscriptionDiscounted = subscriptionOriginal * (1 - subscriptionDiscount);

          const amount = subscriptionWrapper.querySelector('.appstle_subscription_amount');
          const amountSr = subscriptionWrapper.querySelector('.appstle_subscription_amount-appstle-sr-only');
          const compareAmount = subscriptionWrapper.querySelector('.appstle_subscription_compare_amount');
          const compareAmountSr = subscriptionWrapper.querySelector('.appstle_subscription_compare_amount-appstle-sr-only');

          if (amount) amount.textContent = formatPrice(subscriptionDiscounted);
          if (amountSr) amountSr.textContent = `Sale price ${formatPrice(subscriptionDiscounted)}`;
          if (compareAmount) {
            compareAmount.textContent = formatPrice(subscriptionOriginal);
            compareAmount.style.display = subscriptionDiscounted === subscriptionOriginal ? 'none' : 'inline';
          }
          if (compareAmountSr) {
            compareAmountSr.textContent = `Original price ${formatPrice(subscriptionOriginal)}`;
            compareAmountSr.style.display = subscriptionDiscounted === subscriptionOriginal ? 'none' : 'inline';
          }
        }
      }
    }

    // Determine matching card in a bundle by quantity (returns element or null)
    function findMatchingCardInBundle(bundle, qty) {
      if (!bundle) return null;
      const cards = bundle.querySelectorAll('.quantity-card-item');
      return Array.from(cards).find(card => {
        const q = parseInt(card.querySelector('.quantity-cart-number').dataset.qunatity, 10) || 1;
        return q === qty;
      }) || (cards[0] || null);
    }

    // Click handler — determines bundle from the clicked card itself
    // Accepts an options object: { updateCartButton: boolean } — if omitted, auto-detects visibility
    function handleQuantityClick(event, { updateCartButton } = {}) {
      // 'this' will be the clicked card when used as listener; allow both (event or direct)
      const card = (this && this.classList && this.classList.contains('quantity-card-item')) ? this : (event && event.currentTarget) || event && event.target;
      if (!card) return;

      // Auto-detect whether this card is in the visible bundle (if updateCartButton not explicitly provided)
      if (typeof updateCartButton === 'undefined') {
        const bundleEl = card.closest('.bundle-quantity');
        updateCartButton = bundleEl ? (getComputedStyle(bundleEl).display !== 'none') : true;
      }

      const isCardSubscription = !!card.closest('.bundle-quantity.subscription');
      const currentBundle = isCardSubscription ? subscriptionBundle : oneTimeBundle;
      const otherBundle = isCardSubscription ? oneTimeBundle : subscriptionBundle;

      const currentCards = currentBundle ? currentBundle.querySelectorAll('.quantity-card-item') : [];
      const otherCards = otherBundle ? otherBundle.querySelectorAll('.quantity-card-item') : [];

      // set active in current bundle only
      currentCards.forEach(c => c.classList.remove('active'));
      card.classList.add('active');

      // update selected quantity and discount from the clicked card
      selectedQuantity = parseInt(card.querySelector('.quantity-cart-number').dataset.qunatity, 10) || 1;
      const bundleDiscount = getBundleDiscountPercentage(card);

      // Sync the OTHER bundle's active card to match quantity (visual sync)
      if (otherCards.length > 0) {
        otherCards.forEach(c => c.classList.remove('active'));
        let matching = Array.from(otherCards).find(c => {
          const q = parseInt(c.querySelector('.quantity-cart-number').dataset.qunatity, 10) || 1;
          return q === selectedQuantity;
        });
        if (!matching) matching = otherCards[0];
        if (matching) matching.classList.add('active');
      }

      // Finally update prices based on the clicked card (this bundle's discount).
      // Pass updateCartButton flag so hidden-card updates won't overwrite the Add-to-Cart button.
      updatePrice(selectedQuantity, bundleDiscount, updateCartButton);
    }

    // Toggle bundle visibility — set matching active cards and dispatch clicks
    function toggleBundleVisibility() {
      const selectedPlanInput = document.querySelector('input[name="selling_plan"]:checked');
      if (!selectedPlanInput) {
        return;
      }
      const isSubscription = selectedPlanInput.value !== '';
      oneTimeBundle.style.display = isSubscription ? 'none' : 'block';
      subscriptionBundle.style.display = isSubscription ? 'block' : 'none';

      // find matching cards by preferred selectedQuantity
      const matchingVisibleCard = findMatchingCardInBundle(isSubscription ? subscriptionBundle : oneTimeBundle, selectedQuantity);
      const matchingHiddenCard = findMatchingCardInBundle(isSubscription ? oneTimeBundle : subscriptionBundle, selectedQuantity);

      // bind click events to all cards (safe)
      [oneTimeBundle, subscriptionBundle].forEach(bundle => {
        if (!bundle) return;
        const cards = bundle.querySelectorAll('.quantity-card-item');
        cards.forEach(card => {
          card.removeEventListener('click', handleQuantityClick);
          card.addEventListener('click', handleQuantityClick);
        });
      });

      // Dispatch a real click on the visible card first (immediate) — this should set Add-to-Cart correctly.
      if (matchingVisibleCard) {
        matchingVisibleCard.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }

      // For the hidden card: call the handler directly with updateCartButton=false so only Appstle updates.
      if (matchingHiddenCard) {
        setTimeout(() => {
          handleQuantityClick.call(matchingHiddenCard, null, { updateCartButton: false });
        }, 60);
      }

      // Final sanity update after small delay (ensures third-party scripts have run)
      setTimeout(() => {
        const visBundle = isSubscription ? subscriptionBundle : oneTimeBundle;
        const hidBundle = isSubscription ? oneTimeBundle : subscriptionBundle;

        const visActive = visBundle.querySelector('.quantity-card-item.active');
        if (visActive) {
          const qty = parseInt(visActive.querySelector('.quantity-cart-number').dataset.qunatity, 10) || 1;
          const disc = getBundleDiscountPercentage(visActive);
          updatePrice(qty, disc, true); // visible => update cart
        }

        const hidActive = hidBundle.querySelector('.quantity-card-item.active');
        if (hidActive) {
          const qty = parseInt(hidActive.querySelector('.quantity-cart-number').dataset.qunatity, 10) || 1;
          const disc = getBundleDiscountPercentage(hidActive);
          updatePrice(qty, disc, false); // hidden => do NOT update cart
        }
      }, 140);
    }

    // add to cart handler — writes correct selectedQty to form on actual add
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        let qtyInput = document.querySelector('form[action*="/cart/add"] [name="quantity"]');
        if (qtyInput) {
          qtyInput.value = selectedQuantity;
        } else {
          const form = this.closest('form');
          if (form) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'quantity';
            input.value = selectedQuantity;
            form.appendChild(input);
          }
        }
      });
    }

    // watch selling_plan changes
    const sellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]');
    sellingPlanInputs.forEach(input => input.addEventListener('change', toggleBundleVisibility));

    // === INITIALIZATION ===
    // prefer whatever card is already active; otherwise pick first card for subscription (default) or one-time
    const oneTimeCards = oneTimeBundle ? Array.from(oneTimeBundle.querySelectorAll('.quantity-card-item')) : [];
    const subscriptionCards = subscriptionBundle ? Array.from(subscriptionBundle.querySelectorAll('.quantity-card-item')) : [];

    // look for any pre-existing active card
    const preActiveSub = subscriptionBundle ? subscriptionBundle.querySelector('.quantity-card-item.active') : null;
    const preActiveOne = oneTimeBundle ? oneTimeBundle.querySelector('.quantity-card-item.active') : null;

    if (preActiveSub) {
      selectedQuantity = parseInt(preActiveSub.querySelector('.quantity-cart-number').dataset.qunatity, 10) || selectedQuantity;
    } else if (preActiveOne) {
      selectedQuantity = parseInt(preActiveOne.querySelector('.quantity-cart-number').dataset.qunatity, 10) || selectedQuantity;
    } else {
      // no pre-active — pick default based on selling_plan checked (if set), otherwise subscription first card if exists
      const checked = document.querySelector('input[name="selling_plan"]:checked');
      const defaultIsSub = checked ? (checked.value !== '') : true;
      if (defaultIsSub && subscriptionCards.length) {
        subscriptionCards.forEach(c => c.classList.remove('active'));
        subscriptionCards[0].classList.add('active');
        selectedQuantity = parseInt(subscriptionCards[0].querySelector('.quantity-cart-number').dataset.qunatity, 10) || selectedQuantity;
      } else if (oneTimeCards.length) {
        oneTimeCards.forEach(c => c.classList.remove('active'));
        oneTimeCards[0].classList.add('active');
        selectedQuantity = parseInt(oneTimeCards[0].querySelector('.quantity-cart-number').dataset.qunatity, 10) || selectedQuantity;
      }
    }

    // Ensure both bundles have a matching active card for the selectedQuantity
    const matchOne = findMatchingCardInBundle(oneTimeBundle, selectedQuantity);
    const matchSub = findMatchingCardInBundle(subscriptionBundle, selectedQuantity);
    if (matchOne) {
      oneTimeBundle.querySelectorAll('.quantity-card-item').forEach(c => c.classList.remove('active'));
      matchOne.classList.add('active');
    }
    if (matchSub) {
      subscriptionBundle.querySelectorAll('.quantity-card-item').forEach(c => c.classList.remove('active'));
      matchSub.classList.add('active');
    }

    // bind click handlers now
    [oneTimeBundle, subscriptionBundle].forEach(bundle => {
      if (!bundle) return;
      const cards = bundle.querySelectorAll('.quantity-card-item');
      cards.forEach(card => {
        card.removeEventListener('click', handleQuantityClick);
        card.addEventListener('click', handleQuantityClick);
      });
    });

    // initial toggle to set visibility & fire clicks to make Appstle reflect the selected quantity
    toggleBundleVisibility();

    // observe changes to base price on add-to-cart button
    const priceObserver = new MutationObserver(() => {
      const newAddToCartBtn = document.querySelector('[name="add"]');
      if (newAddToCartBtn && newAddToCartBtn.dataset.price && parseFloat(newAddToCartBtn.dataset.price) !== basePrice) {
        basePrice = parseFloat(newAddToCartBtn.dataset.price);
        // update using currently active (visible) card
        const currentChecked = document.querySelector('input[name="selling_plan"]:checked');
        const currentBundle = (currentChecked && currentChecked.value !== '') ? subscriptionBundle : oneTimeBundle;
        const activeCard = currentBundle.querySelector('.quantity-card-item.active') || currentBundle.querySelectorAll('.quantity-card-item')[0];
        const qty = activeCard ? (parseInt(activeCard.querySelector('.quantity-cart-number').dataset.qunatity, 10) || 1) : 1;
        updatePrice(qty, getBundleDiscountPercentage(activeCard), true);
      }
    });
    priceObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Wait for Appstle subscription wrapper to appear
  const appstleObserver = new MutationObserver((mutations, observer) => {
    if (document.querySelector('.appstle_subscription_wrapper')) {
      initializeBundleQuantity();
      observer.disconnect();
    }
  });
  appstleObserver.observe(document.body, { childList: true, subtree: true });
});







// Quntity bundler ends here




  document.addEventListener('DOMContentLoaded', function () {
    const allDetails = document.querySelectorAll('.accordion details');

    allDetails.forEach((detail) => {
      detail.addEventListener('toggle', function () {
        if (this.open) {
          allDetails.forEach((otherDetail) => {
            if (otherDetail !== this) {
              otherDetail.removeAttribute('open');
            }
          });
        }
      });
    });
  });



  document.addEventListener('DOMContentLoaded', function () {
    const allDetails = document.querySelectorAll('.accordion details');

    // 1️⃣ Add active class for default open accordion
    allDetails.forEach((detail) => {
      if (detail.open) {
        detail.closest('accordion-custom')?.classList.add('active');
      }
    });

    // 2️⃣ Handle clicks
    allDetails.forEach((detail) => {
      detail.addEventListener('toggle', function () {
        const currentAccordion = this.closest('accordion-custom');

        if (this.open) {
          // Remove active from all
          document.querySelectorAll('accordion-custom').forEach((acc) => {
            acc.classList.remove('active');
          });

          // Close other accordions
          allDetails.forEach((otherDetail) => {
            if (otherDetail !== this) {
              otherDetail.removeAttribute('open');
            }
          });

          // Add active to current
          currentAccordion?.classList.add('active');
        } else {
          currentAccordion?.classList.remove('active');
        }
      });
    });
  });

